import styled from 'styled-components'

export const StyledTableContainer = styled.div`
    max-height: 330px;
    overflow: auto;
    display: grid;
    grid-gap: 20px;
    padding-right: 20px;

    @media (max-width: 570px) {
        padding-right: 0px;

        ::-webkit-scrollbar {
            width: 10px;
            border-radius: 30px;
        }
    }

    ::-webkit-scrollbar {
        width: 20px;
        border-radius: 30px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #ffffff;
        border-radius: 30px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: rgba(13, 21, 55, 0.1);
        border-radius: 30px;
    }
`

export const StyledRowContainer = styled.div<{ status?: string }>`
    background: #ffffff;
    border: 1px solid #f3f3f3;
    border-radius: 5px;
    transition: 500ms;
    height: 84px;
    padding: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
        border: 1px solid #52bd95;
    }

    .title {
        font-weight: 500;
        font-size: 12px;
        color: #b3b3b3;
        padding-bottom: 3px;
    }

    .detail {
        font-size: 14px;
        color: #222222;
    }

    .status {
        font-weight: 500;
        color: ${({ status }) => (status === '2' ? '#52BD95' : status === '1' ? '#EB5757' : '#D9A300')};
    }

    .hero {
        padding-right: 4.5rem;
        border-right: 1px solid #f3f3f3;
        display: flex;
        align-items: center;
        margin-right: 3rem;

        @media (max-width: 1300px) {
            padding-right: 1rem;
        }

        @media (max-width: 1150px) {
            margin-right: 0.5rem;
        }

        @media (max-width: 1024px) {
            padding-right: 0.2rem;
        }

        @media (max-width: 1000px) {
            padding-right: 3rem;
        }

        @media (max-width: 768px) {
            padding-right: 0.2rem;
        }

        @media (max-width: 380px) {
            margin-right: 0.8rem;
            padding-right: 0.5rem
        }
    }

    .btn {
        height: 44px;
        padding: 0px 1.4rem;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        font-size: 14px;

        @media (max-width: 650px) {
            display: none;
        }
    }

    .last {
        @media (max-width: 540px) {
            display: none;
        }
    }
`
